import Vue from "vue";
import Router from "vue-router";

import Shop from './shop';//所有店铺页面
import Service from './service';
import Login from "../pages/login"; //店铺登录
import ServicerLogin from "../pages/servicerLogin"; //服务商的公路
import Zhuce from "../pages/zhuce"; //注册
import PersonZhuce from "../pages/personZhuce"; //用户注册
import Retrieve from "../pages/retrieve"; //密码找回
import Error from "../pages/error"; //错误页面
import NotFound from "../pages/notfound"; //错误页面
import Success from "../pages/success"; //成功页面
import Home from "../pages/home"; //主页面
//import PeopleHome from "../pages/people/pages/peoplehome";
import Register from "../pages/register"; //注册业
import ShangPin from "../pages/shangpinxinxi.vue"; //商品设置价格页面
import downLoad from "../pages/downLoad.vue"; //下载页面

/* import Vendor from '../pages/people/vendor'
import God from '../pages/people/god' */
Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      name: "404",
      component: () =>
        import(/* webpackChunkName: "error404" */ "../pages/notfound")
    },
    { path: "/", redirect: "/login" },
    { path: "/login", name: "login", component: Login },
    { path: "/shangpin", name: "shangpin", component: ShangPin },
    { path: "/servicerlogin", name: "servicerlogin", component: ServicerLogin },
    { path: "/personZhuce", name: "personZhuce", component: PersonZhuce },
    { path: "/error", name: "error", component: Error },
    { path: "/notfound", name: "notfound", component: NotFound },
    { path: "/success", name: "success", component: Success },
    { path: "/zhuce", name: "zhuce", component: Zhuce },
    { path: "/retrieve", name: "retrieve", component: Retrieve },
    { path: "/register", name: "register", component: Register },
    { path: "/download", name: "download", component: downLoad },
    // { path: "/account/register", name: "register", component: Error },

    {
      path: "/home",
      component: Home,
      redirect: "/welcome",
      children: [
        ...Shop,
        ...Service
        // { path: '/reportware', name: 'reportware', component: ReportWare },
      ]
    }
    /* {
            path: '/shome',
            component: Shome,
            redirect: '/feed',
            children: [
            ]
        },
        {
            path: '/peoplehome',
            component: PeopleHome,
            redirect: '/reportware',
            children: [
            ]
        }, */
  ]
});

// 挂载路由导航守卫
// to   将要访问的路径
// from 代表从哪个路跳转来
// next 是一个函数表示放行
// next() 放行 next('/login')强制跳转
/* router.beforeEach((to, from, next) => {
  if (to.fullPath != store.state.home.editableTabsValue) {
    next(store.state.home.editableTabsValue);
  }
  next();
}); */

// 全局路由守卫
/*router.beforeEach((to, from, next) => {
    // to: Route: 即将要进入的目标 路由对象
    // from: Route: 当前导航正要离开的路由
    // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
    const nextRoute = ['business', 'classInfo', 'goodsInfo', 'information', 'peopleInfo', 'personal', 'in', 'out', 'god', 'vendor', 'welcome'];
    // let isLogin=localStorage.getItem('token');
    let account_id = window.sessionStorage.getItem("account_id");
    // 未登录状态；当路由到nextRoute指定页时，跳转至login
    console.log(nextRoute.indexOf(to.name));
    if (nextRoute.indexOf(to.name) >= 0 && !account_id) {
        next({
            path: '/login',
            // 将跳转的路由path作为参数，登录成功后跳转到该路由
            // query: { redirect: to.fullPath }
        })
    } else {
        next();
    }
    console.log(to.name);
    // 已登录状态；当路由到login时，跳转至home
    if (to.name === 'login' || to.name === 'zhuce' || to.name === 'personZhuce') {
        if (account_id) {
            console.log('已登录');
            router.push({ path: 'home' });
        }
    }

});*/

export default router;
